import { Container } from "react-bootstrap";
import Header from "../../components/Header/category";
import TeamBlock from "../../components/Home/team";
import LeistungenBlock from "../../components/Home/leistungen";
import FAQBlock from "../../components/Home/faq";
import ReferalBlock from "../../components/Home/referal";
import AditionalBlock from "../../components/Content/aditional";
import OffersBlock from "../../components/Content/offer";
import AppointmentScheduler from "../../components/Content/scheduler";

const data = {
  header: {
    title: "Preise & Angebote",
    categoryname: "P&A",
    description:
      "Hier finden Sie unsere aktuellen Preise, Sonderangebote und Rabatte. Profitieren Sie von unseren attraktiven Konditionen für verschiedene Fahrkurse, einschließlich Sonderaktionen für Studenten und Gruppenanmeldungen. Starten Sie mit der Fahrschule Bergedorf günstig in Ihre Fahrausbildung!",
    image: "/preise.jpg",
  },
  referal: {
    title: "50€ Gutschein für deine Empfehlung!",
    descr:
      "Erhalte einen 50€ Gutschein für jede Weiterempfehlung, nutzbar für deine nächste Fahrstunde bei uns. Unsere professionellen Fahrlehrer garantieren eine auf dich abgestimmte, qualitativ hochwertige Ausbildung. Teile dieses Angebot, sichere dir deinen Vorteil und vereinbare deinen Termin. Angebot ist zeitlich begrenzt, es gelten unsere Bedingungen.",
    image: "/referal.jpg",
  },
  aditional: {
    title: "Neukunden Aktion",
    description:
      "Erstmalige Anmelder erhalten 25% Rabatt auf den Grundkurs. Nutze diese Chance, um mit unserer Fahrschule in die Welt des Fahrens einzusteigen. Unser Ziel ist es, dir einen optimalen Start in deine Fahrausbildung zu bieten.",
    btnName: "ANMELDEN",
  },
  offers: [
    {
      title: "Frühbucher Bonus",
      desc: "Profitiere von unserem 20% Rabatt auf Intensivkurse, wenn du dich mindestens drei Monate im Voraus anmeldest. Dieser Bonus ermöglicht es dir, umfassend und intensiv zu lernen, während du gleichzeitig Geld sparst. Ideal für diejenigen, die ihre Fahrkenntnisse schnell und effizient verbessern wollen.",
      image: "/referal.jpg",
    },
    {
      title: "Wochenend Deal",
      desc: "Erhalte 10% Rabatt auf unsere Wochenendkurse und genieße die Flexibilität des Lernens außerhalb deiner Arbeitszeit. Dieses Angebot ist perfekt für Beschäftigte, die unter der Woche wenig Zeit haben.",
      image: "/referal.jpg",
    },
    {
      title: "Familien Vorteil",
      desc: "Familien, die gemeinsam lernen, erhalten jeweils 15% Rabatt auf alle Fahrstunden. Nutze diese Gelegenheit, um als Familie das Fahren zu erlernen und dabei zu sparen. Dies fördert nicht nur das gemeinsame Lernen, sondern macht die Fahrausbildung auch erschwinglicher.",
      image: "/referal.jpg",
    },
  ],
};

const Preise = () => {
  return (
    <>
      <header className="layout layout__min layout__bg layout__bg_primary position-relative overflow-hidden">
        <Container fluid>
          <Header props={data.header} />
        </Container>
      </header>
      <main>
        <section className="layout layout__bg layout__bg_secondary layout_mt">
          <Container fluid>
            <AppointmentScheduler />
          </Container>
        </section>
        <ReferalBlock
          title={data.referal.title}
          desc={data.referal.descr}
          img={data.referal.image}
        />
        {data.offers.length > 0 && <OffersBlock offers={data.offers} />}
        <AditionalBlock aditional={data.aditional} />
        <LeistungenBlock />
        <TeamBlock />
        <FAQBlock />
      </main>
    </>
  );
};

export default Preise;
